import type { CardProps } from 'src/notifications/cardTypes';
import DocumentActions from '../DocumentActions';
import NotificationCardShell from '../NotificationCardShell';
import NotificationLinkButton from '../NotificationLinkButton';

export default function SuitabilityReportCompleteCard({
  notification,
  payload,
  onClose,
}: CardProps<'SUITABILITY_REPORT_COMPLETE'>) {
  const failed = payload.status === 'FAILED';
  const editPath = `/client/${payload.client_id}/document/suitability-reports/${payload.suitability_report_id}/edit`;

  return (
    <NotificationCardShell
      notification={notification}
      title={failed ? 'Suitability report failed' : 'Suitability report ready'}
      body={
        failed
          ? 'Your suitability report could not be generated.'
          : 'Your suitability report has been generated.'
      }
      clientId={payload.client_id}
      actions={
        <>
          <NotificationLinkButton
            primary
            to={`/client/${payload.client_id}/document/suitability-reports`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          {!failed && (
            <DocumentActions
              clientId={payload.client_id}
              documentId={payload.suitability_report_id}
              fileId={payload.file_id}
              editPath={editPath}
              onClose={onClose}
            />
          )}
        </>
      }
    />
  );
}
